<!-- 火炬计划 -->
<template>
  <div class="other-torch">
    <div>
      <h1>火炬计划</h1>
      <ul>
        <li>再来人希望通过正在接受或已接受再来人服务的学员，像火炬一样传递，让更多的学员了解再来人的服务。再来人将全球最优质的资源产品化，让所有学员都能够拥有并且终身受益，在帮助学员在留学这件事上，充分发挥潜力、实现个人目标。</li>
        <li>
          当您每推荐一名学员成功签约后，您和推荐的学员都将获得以下三种奖励中的其中一种：<br />
          1.3000元的奖励;<br />
          2.导师个性化辅导时间60分钟；<br />
          3.同申请方向内多增一个申请项目；
        </li>
        <li>
          具体流程如下：<br />
          1.微信扫描该页面下方的二维码；<br />
          2.在跳转的页面中，长按手机屏幕，保存图片，分享给好友；<br />
          3.好友识别您分享的二维码，进入报名页面，报名成功后，我们会在第一时间联系您的推荐的学员，敬请等待。
        </li>
      </ul>
      <div class="other-torch-code">
        <div id="qrcode"></div>
        <p>扫描二维码，生成独有的“火炬计划”二维码，分享给好友，赢奖励。</p>
      </div>
    </div>
  </div>
</template>
<script>
import QRCode from 'qrcodejs2'
// api
import { infoQueryDetail } from '@/api/info'
// less
import './other.less'
export default {
  name: 'other-torch',
  components: {},
  data () {
    return {
    }
  },
  computed: {},
  mounted () {
    this.getDetail()
  },
  methods: {
    getDetail () {
      infoQueryDetail({}).then(res => {
        let http = window.location.protocol
        let url = (http === 'http:') ? 'http://in.zailairen.com' : 'https://open.zailairen.com'
        this.qrcode(`${url}/referrer/page/qr/${res.data.model.referralCode}`)
      })
    },
    qrcode (href) {
      let qrcode = new QRCode('qrcode', {
        width: 200,
        height: 200, // 高度
        text: href // 二维码内容
      })
      console.log(href)
      console.log(qrcode)
    }
  }
}
</script>
<style lang='less' scoped>
</style>
